import { StyleSheet } from 'react-native';
import colors, { appTheme } from '@/config/colors';

export const styles = StyleSheet.create({
  containerStyle: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingBottom: 25,
  },
  body: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  bold_text: {
    fontWeight: '700',
  },
  question_text: {
    fontSize: 20,
    fontWeight: '500',
    marginBottom: 15,
  },
  change_container: {
    alignItems: 'center',
    marginTop: 15,
    backgroundColor: appTheme.primary,
    borderRadius: 4,
  },
  change: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
  },
  change_text: {
    fontSize: 18,
    color: colors.white,
    marginHorizontal: 10,
    fontWeight: '700',
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    borderColor: colors.black,
    borderWidth: 1,
  },
  options_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
  },
  options_text: {
    fontWeight: '700',
    fontSize: 20,
  },
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#00000099',
  },
  underline: {
    width: '100%',
    height: 1,
    marginBottom: 10,
    backgroundColor: colors.grey,
  },
  modalView: {
    backgroundColor: 'white',
    padding: 10,
    alignItems: 'center',
    maxWidth: 500,
    marginHorizontal: 10,
  },
  button: {
    width: '100%',
    padding: 10,
    backgroundColor: colors.darkPurpleBlue,
    borderColor: 'transparent',
  },

  modalButton: {
    color: colors.white,
    fontWeight: '700',
    textAlign: 'center',
  },
  modalTitle: {
    marginBottom: 10,
    textAlign: 'center',
    opacity: 0.5,
    fontWeight: '700',
  },
  modalText: {
    marginBottom: 15,
    fontSize: 22,
  },
  lockMargin: { marginBottom: 140 },
  errorText: { color: colors.red, textAlign: 'center', marginBottom: 10 },
  borderStyle: { borderBottomColor: colors.black, borderBottomWidth: 1 },
  opacity0: {
    opacity: 0,
  },
  opacity1: {
    opacity: 1,
  },
  paddingTop: {
    paddingTop: 10,
  },
});
